import { Component, inject, OnInit } from '@angular/core';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { SimpleArea } from 'src/app/Interfaces/Admin/charts/SimpleChartArea.interface';
import { Data_Cont_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Reports/Data_Contribution_FIN.interface';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-contributions-ap',
    templateUrl: './contributions-ap.component.html',
    styleUrls: ['./contributions-ap.component.scss', '../../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class ContributionsAPComponent implements OnInit {

  //+================== VARIABLES GENERAL ==================+\\
  public CurrentDate!: Date

  //+================== VARIABLES DATA LIBRARIES ==================+\\
  public DataChartAreaFIN: SimpleArea = { Data: [], Date: [], SerieName: 'Contribuciones', Subtitle: ``, Title: 'Contribuciones totales Processes', Total: 0, load: false }

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //-========================= SERVICES =========================-\\
  public Service_FIN = inject(LibraryFINService)

  ngOnInit(): void {
    this.CurrentDate = new Date();
    this.Load_Cont_FIN();
  }

  //-================== FUNCTTION FOR LOAD CONT FIN ==================-\\
  private async Load_Cont_FIN(): Promise<void> {

    try {

      const resContributionFIN: any = await firstValueFrom(this.Service_FIN.Get_Contribution_FIN({ Type: 3, StartDate: '', EndDate: this.CurrentDate }))

      if (resContributionFIN.success) {

        const DataContribution: Data_Cont_FIN[] = resContributionFIN.operation.Data
        const totalContribution: number = resContributionFIN.operation.total

        const oldDate: Date = new Date(Math.min(...DataContribution.map((item: Data_Cont_FIN) => new Date(item.DateD).getTime())));

        this.DataChartAreaFIN = {
          ...this.DataChartAreaFIN,
          Data: DataContribution.map((item: Data_Cont_FIN) => item.DataD),
          Date: DataContribution.map((item: Data_Cont_FIN) => item.DateD),
          Subtitle: `Periodo: ${moment(oldDate).utc().format('MM/DD/YYYY')} - ${moment(this.CurrentDate).utc().format('DD/MM/YYYY')}`,
          Total: totalContribution,
          load: true
        };

      }


    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (contribuciones FIN)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

    }

  }

}
